import React from 'react';
import Navigation from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Map from './components/Map';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <>
      <Navigation />
      <Hero />
      <About />
      <Gallery />
      <Map />
      <Contact />
    </>
  );
}

export default App;
